export default __webpack_public_path__ + "static/social-estados_en-3134b4d1fd5159c654e6cc21584c2bce.png";